import * as React from "react";
import { useContext, createContext } from "react";
import type { FC, PropsWithChildren } from "react";

import { noop } from "../../../../../Common/TypingUtils";

type UpdateHeightCallback = (cellId: string, cellHeight: number) => void;

const UpdateHeightCallbackContext = createContext<UpdateHeightCallback>(noop);

interface ProviderProps {
    onUpdate: UpdateHeightCallback;
}

export const UpdateHeightCallbackProvider: FC<PropsWithChildren<ProviderProps>> = ({ onUpdate, children }) => (
    <UpdateHeightCallbackContext.Provider value={onUpdate}>{children}</UpdateHeightCallbackContext.Provider>
);

export const useUpdateHeightCallback = () => useContext(UpdateHeightCallbackContext);
